"use client";
import { Asset as e } from "../assets/Asset.js";
import { AssetSvg as t } from "../assets/AssetSvg.js";
import { jsx as n, jsxs as r } from "react/jsx-runtime";
import { useId as i } from "react";
//#region src/components/flags/NZFlag.tsx
var a = (e) => {
	let a = i();
	return /* @__PURE__ */ r(t, {
		viewBox: "0 0 24 24",
		fill: "none",
		...e,
		children: [/* @__PURE__ */ r("g", {
			clipPath: `url(#${a}-clip0_103_177)`,
			children: [
				/* @__PURE__ */ n("mask", {
					id: `${a}-path-1-inside-1_103_177`,
					fill: "white",
					children: /* @__PURE__ */ n("path", { d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z" })
				}),
				/* @__PURE__ */ n("path", {
					d: "M-8.04004 0H27.96V24.0003H-8.04004V0Z",
					fill: "#0052B4"
				}),
				/* @__PURE__ */ n("path", {
					d: "M21.8639 10.4353L22.1021 11.1685H22.8729L22.2493 11.6216L22.4875 12.3547L21.8639 11.9017L21.2401 12.3547L21.4784 11.6216L20.8547 11.1685H21.6255L21.8639 10.4353ZM19.1081 15.7138L19.4655 16.8136H20.6217L19.6862 17.4933L20.0436 18.593L19.1081 17.9133L18.1726 18.593L18.5299 17.4933L17.5944 16.8136H18.7507L19.1081 15.7138ZM19.2122 7.07617L19.51 7.99277H20.4736L19.694 8.55906L19.9917 9.47552L19.2122 8.90908L18.4326 9.47552L18.7303 8.55906L17.9508 7.99277H18.9143L19.2122 7.07617ZM16.5606 10.4034L16.9179 11.5031H18.0743L17.1387 12.1828L17.4961 13.2825L16.5606 12.6029L15.6251 13.2825L15.9824 12.1828L15.0469 11.5031H16.2032L16.5606 10.4034Z",
					fill: "#D80027"
				}),
				/* @__PURE__ */ n("path", {
					d: "M9.96022 -0.000244141V2.14879L6.78364 3.91279H9.96022V8.08648H5.80384L9.96022 10.396V11.9995H8.08358L2.91673 9.12893V11.9995H-0.996303V8.58422L-7.14366 11.9995H-8.03979V9.85125L-4.86392 8.08648H-8.03979V3.91279H-3.88411L-8.03979 1.60415V-0.000244141H-6.16386L-0.996303 2.87118V-0.000244141H2.91673V3.41505L9.06416 -0.000244141H9.96022Z",
					fill: "white"
				}),
				/* @__PURE__ */ n("path", {
					d: "M2.08497 -0.000244141H-0.165031V4.87481H-8.04004V7.12481H-0.165031V11.9999H2.08497V7.12481H9.95998V4.87481H2.08497V-0.000244141Z",
					fill: "#D80027"
				}),
				/* @__PURE__ */ n("path", {
					d: "M2.9165 8.08667L9.95999 11.9998V10.8932L4.90825 8.08667H2.9165Z",
					fill: "#0052B4"
				}),
				/* @__PURE__ */ n("path", {
					d: "M2.9165 8.08667L9.95999 11.9998V10.8932L4.90825 8.08667H2.9165Z",
					fill: "white"
				}),
				/* @__PURE__ */ n("path", {
					d: "M2.91649 8.08667L9.95998 11.9998V10.8932L4.90823 8.08667H2.91649ZM-2.98836 8.08667L-8.04004 10.8932V11.9998L-0.996548 8.08667H-2.98836Z",
					fill: "#D80027"
				}),
				/* @__PURE__ */ n("path", {
					d: "M-0.996548 3.91286L-8.04004 -0.000244141V1.10633L-2.98829 3.91286H-0.996548ZM4.9083 3.91286L9.95998 1.10633V-0.000244141L2.91649 3.91286H4.9083Z",
					fill: "#D80027"
				})
			]
		}), /* @__PURE__ */ n("defs", { children: /* @__PURE__ */ n("clipPath", {
			id: `${a}-clip0_103_177`,
			children: /* @__PURE__ */ n("path", {
				d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z",
				fill: "white"
			})
		}) })]
	});
}, o = {
	12: {
		Artwork: a,
		width: 12,
		height: 12
	},
	16: {
		Artwork: a,
		width: 16,
		height: 16
	},
	20: {
		Artwork: a,
		width: 20,
		height: 20
	},
	24: {
		Artwork: a,
		width: 24,
		height: 24
	}
}, s = ({ size: t = 16, ...r }) => /* @__PURE__ */ n(e, {
	source: o[t],
	frame: "circle",
	...r
});
//#endregion
export { s as NZFlag };
